import _ from 'lodash';
import { validateFieldId } from '../utils/validateFieldId';
import { validateFormulaParams } from '../utils/validateFormula';
import { validateAiConfig } from '../utils/validateAiConfig';

const VALIDATION_FUNCS = [validateFieldId, validateFormulaParams, validateAiConfig];

/**
 * Validate func for newId property
 * @param  {field - current immutable field in editing catalog} field
 * @param  {allFields - all immutable fields in editing catalog} allFields
 * @return {Array} [{ fieldId: id, errorType: 'fieldId', fieldUuid: 0.4989871972272757, message: "something went wrong" }, ...etc ]
 * @property {string} fieldId - id of field
 * @property {string} errorType - type of error
 * @property {string} fieldUuid - uuid of field
 * @property {string} message - error message
 */
export class Field {
  static components = {};

  static getComponent(type) {
    return this.components[type];
  }

  static getDefaultValue(field) {
    const isHaveDefaultValue = field.getIn(['config', 'defaultValue']);
    const defaultValue = isHaveDefaultValue ? field.getIn(['config', 'defaultEmptyValue']) : null;
    return defaultValue;
  }

  static availableFormulaTypes = [];

  static availableInFormulas = false;

  static validateField(field, allFields) {
    let errors = [];

    VALIDATION_FUNCS.map((validate) => {
      const fieldErrors = validate(field, allFields);

      errors = errors.concat(fieldErrors);
    });

    return errors;
  }

  static boardWitchColor() {
    return false;
  }

  static convertFilterToRecordValue() {}

  static getCanComponentExpandWidthOrHeight(value) {}
}
